import { useState } from "react"
import { render } from "storyblok-rich-text-react-renderer"
import { Button } from "iq-blueberry"

import SbEditable from "@mkt/ui/components/common/SbEditable"
import Img from "@mkt/ui/components/common/Img"

import Tabs from "@mkt/cp/src/components/Tabs"
import TwoCards from "@mkt/cp/src/components/TwoCards"
import FAQ from "@mkt/cp/src/components/FAQ"

import Benefits from './components/Benefits/index.js'
import Brands from './components/Brands/index.js'
import Issuers from './components/Issuers/index.js'

import * as S from "./styles.js"
import assertAssetURL from "@mkt/utils/assertAssetUrl.js"

const CreditCardDetails = ({ content }) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <SbEditable content={content}>
      <div css={S.wrapper}>
        <div css={S.content}>
          <div css={S.infoContainer}>
            {content?.title && (
              <h2 css={S.title}>
                {render(content?.title)}
              </h2>
            )}

            <figure css={S.imageContainer("mobile")}>
              <picture>
                <Img
                  src={assertAssetURL(content?.image_mobile.filename)}
                  alt={content?.title}
                  css={S.image}
                  loading="eager"
                />
              </picture>
            </figure>

            <p css={S.text}>
              {render(content?.text)}
            </p>

            <div css={S.button(showMore)}>
              <Button
                type="secondary"
                justify="center"
                expand="x"
                onClick={() => setShowMore(true)}
              >
                Ver mais
              </Button>
            </div>
          </div>

          <figure css={S.imageContainer("desktop")}>
            <picture>
              <Img
                src={assertAssetURL(content?.image_desktop.filename)}
                alt={content?.title}
                css={S.image}
                loading="eager"
              />
            </picture>
          </figure>
        </div>

        <div css={S.sections(showMore)}>
          {content?.online[0] && <TwoCards content={content?.online[0]} />}
          {content?.benefits[0] && <Benefits blok={content?.benefits[0]} />}
          {content?.brands[0] && <Brands blok={content?.brands[0]} />}
          {content?.modalities[0] && <Tabs content={content?.modalities[0]} />}
          {content?.issuers[0] && <Issuers blok={content?.issuers[0]} />}
          {content?.conclusion[0] && (
            <TwoCards
              content={content?.conclusion[0]}
              showLessButton={true}
              handleClick={() => setShowMore(false)}
            />
          )}
        </div>

        {content?.faq[0] && <FAQ content={content?.faq[0]} />}
      </div>
    </SbEditable>
  )
}

export default CreditCardDetails
